import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles({
  container: {
    padding: '3.2%',
    borderRadius: '0px',
  },
});
